// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class Prescription {
    static getAttributeTypeMap() {
        return Prescription.attributeTypeMap;
    }
}
Prescription.discriminator = undefined;
Prescription.attributeTypeMap = [
    {
        "name": "ndc",
        "baseName": "ndc",
        "type": "string"
    },
    {
        "name": "writtenOn",
        "baseName": "writtenOn",
        "type": "Date"
    },
    {
        "name": "daySupply",
        "baseName": "daySupply",
        "type": "number"
    },
    {
        "name": "refills",
        "baseName": "refills",
        "type": "number"
    },
    {
        "name": "quantity",
        "baseName": "quantity",
        "type": "number"
    },
    {
        "name": "directions",
        "baseName": "directions",
        "type": "string"
    }
];
//# sourceMappingURL=prescription.js.map